<dx-form id="form" 
[formData]="servicesForm" 
(onFieldDataChanged)="handleFormFieldsChange($event)"
[width]="350"
>  
    <dxi-item itemType="group" cssClass="form-group" [colCount]="1">
        <dxi-item>
          <label class="required-label">Services:</label>
          <div>
            <dx-tag-box #ServicesTagBox style="margin-top: 5px;"
              [items]="services"
              displayExpr="description"
              valueExpr="name"
              [width]="350"
              [searchEnabled]="true"
              placeholder="Choose Service..."
              [hideSelectedItems]="true"
              [inputAttr]="{ 'aria-label': 'Service' }"
              (onValueChanged)="handleTagBoxChange($event)"> 
            </dx-tag-box>
          </div>
        </dxi-item>
        
        <dxi-item itemType="group" colSpan="1">
          
          <dxi-item  
            dataField="Wallets"
            [colSpan]="1"
            editorType="dxTextBox"
            [label]="{text: 'Initial Wallets Required', cssClass: 'required-label' }"
            [editorOptions]="{
               height:40, 
               width: 350, 
               disabled: true, 
               value : 1,
               elementAttr: {
                style: 'background-color: rgb(238, 238, 238);padding-top:5px;'  
               }
            }"
          >
          </dxi-item>
        </dxi-item>
    </dxi-item>
</dx-form>
